<template>
  <div class="p-login-form">
    <h2 class="p-login-form__title">パスワードを変更してください</h2>
    <form id="changeForm" action="/api/login/pass-update/">
      <ul class="p-login-form-list">
        <li class="p-login-form-list__item">
          <div class="c-input">
            <div class="c-input__title">初回ログインパスワード</div>
            <input
              class="c-input__item"
              type="password"
              name="password_old"
              value=""
              placeholder="初回ログインパスワードを入力してください"
            />
            <div class="c-error">
              <div class="c-error__text"></div>
            </div>
          </div>
        </li>
        <li class="p-login-form-list__item">
          <div class="c-input">
            <div class="c-input__title">新しいパスワード</div>
            <input
              class="c-input__item"
              type="password"
              name="password_new"
              value=""
              placeholder="新しいパスワードを入力してください"
            />
          </div>
        </li>
        <li class="p-login-form-list__item">
          <div class="c-input">
            <div class="c-input__title">新しいパスワード（確認）</div>
            <input
              class="c-input__item"
              type="password"
              name="password_new_retype"
              value=""
              placeholder="確認のため、再度入力してください"
            />
            <div class="c-error">
              <div class="c-error__text"></div>
            </div>
          </div>
          <ul class="p-login-form-suppl-list">
            <li class="p-login-form-suppl-list__item">
              パスワードは数字、英字大・小、記号(.+/-!?_#@)から2種類以上組み合わせて入力してください</li>
            <li class="p-login-form-suppl-list__item">パスワードは6文字以上32文字以下で入力してください</li>
          </ul>
        </li>
      </ul>
      <ul class="p-login-form-list p-login-form-list--bottom">
        <li class="p-login-form-list__item">
          <a
            class="c-btn c-btn--blue u-w250"
            href="#"
            name="change"
            @click="submit($event)"
          >
            <p class="c-btn__text">パスワードを変更する</p>
          </a>
          <div class="p-login-form-suppl">
            <p class="p-login-form-suppl__text">再ログインが必要になります</p>
          </div>
        </li>
      </ul>
    </form>
  </div>
</template>

<script>
import axios from 'axios';

export default {
  props: {
  },
  methods: {
    submit: function (event) {
      event.preventDefault();
      var changeButton = $('a[name="change"]');
      var changeForm = $('#changeForm');

      var oldPassword = changeForm.find('input[name=password_old]').prop('value');
      var newPassword = changeForm.find('input[name=password_new]').prop('value');
      var newPasswordConfirm = changeForm.find('input[name=password_new_retype]').prop('value');
      if(newPassword == newPasswordConfirm){
        // フォーム要素取得
        const data = {
          password: oldPassword,
          new_password: newPassword,
        };

        // ローディング表示設定
        changeButton.addClass('is-loading').prop('disabled', 'disabled');

        // 配信状況データの取得処理実行
        axios.post(changeForm.prop('action'), data)
          .then(res => {
            if (res.data.result == 'OK') {
              location.href = "/login";
            } else {
              changeButton.removeClass('is-loading').prop('disabled', '');
              if (res.data.errors) {
                // エラーメッセージ非表示設定
                changeForm.find('.c-input').removeClass('is-error');
                changeForm.find('.c-error').removeClass('is-active');

                for (let elementName in res.data.errors) {
                  let message = res.data.errors[elementName];

                  // エラーメッセージ表示設定
                  changeForm.find('input[name=' + elementName + ']')
                    .closest('li')
                    .find('.c-error')
                    .addClass('is-active')
                    .find('.c-error__text')
                    .text(message)

                  changeForm.find('input[name=' + elementName + ']')
                    .closest('.c-input')
                    .addClass('is-error');

                }
              } else{
                // エラーメッセージ非表示設定
                changeForm.find('.c-input').removeClass('is-error');
                changeForm.find('.c-error').removeClass('is-active');
              }
            }
          })
          .catch(_e => {
            // エラーメッセージ表示設定
            changeForm.find('input[name=password_new_retype]')
              .closest('li')
              .find('.c-error')
              .addClass('is-active')
              .find('.c-error__text')
              .text('予期せぬエラーが発生しました');
          });
      } else {
        // エラーメッセージ表示設定
        changeForm.find('input[name=password_new_retype]')
          .closest('li')
          .find('.c-error')
          .addClass('is-active')
          .find('.c-error__text')
          .text('新しいパスワードが一致していません');
      }
    },
  }
}
</script>
